import axios from "axios";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { API_ENDPOINTS, BASE_URL } from "../../utils/api";

function Brands() {
  const [brands, setBrands] = useState([]);
  const [visibleBrands, setVisibleBrands] = useState(8);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    async function getBrands() {
      try {
        const response = await axios.get(
          `${BASE_URL}${API_ENDPOINTS.getBrands}`
        );
        setBrands(response.data.result);
      } catch (error) {
        console.log("Fetching data is not successful", error);
      }
    }
    getBrands();
  }, []);

  const handleShowMore = () => {
    setVisibleBrands((prevVisible) => prevVisible + 8);
  };

  return (
    <section style={{
      padding: '40px 20px',
      backgroundColor: '#f9f9f9',
      margin: '0 auto',
      maxWidth: '1400px'
    }}>
      <div style={{
        textAlign: 'center',
        marginBottom: '40px'
      }}>
        <h2 style={{
          color: 'rgba(111, 135, 81, 1)',
          fontSize: '32px',
          fontWeight: '600',
          margin: '0'
        }}>Brands</h2>
      </div>

      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        gap: '20px',
        padding: '0 10px',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        {brands.slice(0, visibleBrands).map(({ _id, brandName, imgData }) => (
          <div key={_id} style={{
            width: isDesktop ? 'calc(25% - 15px)' : 'calc(50% - 10px)',
            marginBottom: '20px'
          }}>
            <div style={{
              backgroundColor: '#fff',
              borderRadius: '8px',
              overflow: 'hidden',
              boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
              transition: 'transform 0.3s ease',
              height: '100%',
              ':hover': {
                transform: 'translateY(-5px)'
              }
            }}>
              <div style={{
                position: 'relative',
                width: '100%',
                paddingTop: '80%'  // Maintain aspect ratio
              }}>
                <NavLink to={`/brand/${_id}`}>
                  <img
                    src={imgData}
                    alt={brandName}
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      opacity: 1,
                      transition: 'opacity 0.3s ease'
                    }}
                  />
                </NavLink>
              </div>
              
              <div style={{
                padding: '15px',
                textAlign: 'center'
              }}>
                <h3 style={{
                  margin: '0',
                  fontSize: '18px',
                  fontWeight: '500'
                }}>
                  <NavLink 
                    to={`/${brandName}/${_id}`}
                    style={{
                      color: '#333',
                      textDecoration: 'none',
                      ':hover': {
                        color: 'rgba(111, 135, 81, 1)'
                      }
                    }}
                  >
                    {brandName}
                  </NavLink>
                </h3>
              </div>
            </div>
          </div>
        ))}
      </div>

      {visibleBrands < brands.length && (
        <div style={{
          textAlign: 'center',
          marginTop: '40px'
        }}>
          <button
            onClick={handleShowMore}
            style={{
              backgroundColor: 'rgba(111, 135, 81, 1)',
              border: 'none',
              padding: '12px 24px',
              fontSize: '16px',
              color: '#fff',
              borderRadius: '5px',
              cursor: 'pointer',
              transition: 'background-color 0.3s ease',
              ':hover': {
                backgroundColor: 'rgba(111, 135, 81, 0.8)'
              }
            }}
          >
            Show More
          </button>
        </div>
      )}
    </section>
  );
}

export default Brands;